import LocationGoogleRating from '@/components/LocationGoogleRating'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: LocationGoogleRating,
	}

	let page = vuewidget(dom, options)
	return page
}
